import React from "react";
import { useDispatch, useSelector } from "react-redux";

import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { hideHelp, showHelp } from "../../../store/actions/helpPanel";

const HelpContextIcon = ({ screen }) => {
  const dispatch = useDispatch();
  const { open } = useSelector((state) => state.helpPanel);

  const handleClick = () => {
    if (open) dispatch(hideHelp());
    else dispatch(showHelp(screen));
  };

  return (
    <IconButton color="info" onClick={handleClick} sx={{ marginLeft: "15px" }}>
      <InfoOutlinedIcon sx={{ cursor: "pointer", fontSize: "20px" }} />
    </IconButton>
  );
};

export default HelpContextIcon;
